import { CapitalDepositStatus } from '__generated__/GQL';
import { MachineGuards } from 'common/bento/types/MachineConfig';

import getIsAddressFilled from '../../../lib/getIsAddressFilled';
import { Model } from './model';

export enum Guard {
  HasCompletedQuestions = 'hasCompletedQuestions',
  HasNotFilledPersonalAddress = 'hasNotFilledPersonalAddress',
  HasPartner = 'hasPartner',
  HasSameAddress = 'hasSameAddress',
  IsConfirmedPartner = 'isConfirmedPartner',
  IsMandatee = 'isMandatee',
}

const guards: MachineGuards<Model, Guard> = {
  hasCompletedQuestions: ({ getModuleData }) =>
    getModuleData().data.viewer.company.capitalDeposit.status ===
    CapitalDepositStatus.FormCompleted,

  hasNotFilledPersonalAddress: ({ getModuleData }) => {
    const { profile } = getModuleData().data.viewer;
    return !getIsAddressFilled(profile);
  },

  hasPartner: (context, event) => {
    if (event.type !== 'SUBMIT_HAS_PARTNER') {
      throw new Error(`hasPartner called on event ${event.type}`);
    }

    return event.data.hasPartner;
  },

  hasSameAddress: (context, event) => {
    if (event.type !== 'SUBMIT_SAME_ADDRESS') {
      throw new Error(`hasSameAddress called on event ${event.type}`);
    }

    return event.data.hasSameAddress;
  },

  isConfirmedPartner: (context) => {
    return Boolean(
      context.getModuleData().data.viewer.company.capitalDeposit
        .isConfirmedPartner,
    );
  },

  isMandatee: (context) => {
    return Boolean(context.getModuleData().data.viewer.companyUser.isMandatee);
  },
};

export default guards;
